import { type FeatureGate, type StatsigClient, useFeatureGate, useStatsigClient } from '@statsig/react-bindings';
import { FeatureFlagProvider as provider } from './provider';
type Flags = 'recommendations-rules' | 'copilot' | 'copilot-sidenav' | 'reporting-solution-in-app-dashboard' | 'light-dark-mode' | 'creative-tagging' | 'tiktok-creative-score' | 'chatgpt-datasource' | 'creative-insights-gads' | 'creative-context-validation-hub' | 'bo-risk-tolerance';
// Feature flags represent feature gates in statsig.com
export const FEATURE_FLAGS: Record<string, Flags> = {
  recommendationsRules: 'recommendations-rules',
  /** Fullscreen Alvie AI Pro (`/ai`) and its settings/nav entry. */
  copilot: 'copilot',
  /** Sidenav drawer Alvie AI (top-nav toggle, ⌘L, page tools). */
  copilotSidenav: 'copilot-sidenav',
  reportingSolutionInAppDashboard: 'reporting-solution-in-app-dashboard',
  lightDarkMode: 'light-dark-mode',
  creativeTagging: 'creative-tagging',
  tiktokCreativeScore: 'tiktok-creative-score',
  chatgptDatasource: 'chatgpt-datasource',
  creativeInsightsGads: 'creative-insights-gads',
  creativeContextValidationHub: 'creative-context-validation-hub',
  boRiskTolerance: 'bo-risk-tolerance'
};
export const FeatureFlagProvider = provider;
export const useFeatureFlagClient = useStatsigClient;
export const useFeatureFlag = flag => {
  return useFeatureGate(flag);
};
export const getFeatureFlag = async (client: StatsigClient, flag: Flags): Promise<boolean> => {
  return client.checkGate(flag);
};